module.exports = __webpack_public_path__ + "static/media/emj15.0a40c31e.svg";